export default "__VITE_ASSET__8ASFyRg9__"